import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useAuth } from '../../context/AuthContext'
import { RiUserLine, RiMailLine, RiPhoneLine, RiLockLine, RiEyeLine, RiEyeOffLine, RiLoader4Line } from 'react-icons/ri'
import toast from 'react-hot-toast'

export default function Register() {
  const { register: registerUser } = useAuth()
  const navigate = useNavigate()
  const [showPw, setShowPw] = useState(false)

  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm()

  const onSubmit = async (data) => {
    try {
      await registerUser({ name: data.name, email: data.email, phone: data.phone, password: data.password })
      toast.success('Account created successfully! Welcome to Salon Vora.')
      navigate('/dashboard')
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed')
    }
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-display text-salon-dark text-3xl font-bold">Create Account</h1>
        <p className="text-salon-muted font-body mt-2">Join Salon Vora and book effortlessly</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label className="input-label">Full Name</label>
          <div className="relative">
            <RiUserLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('name', { required: 'Name is required' })}
              className="input-field pl-10" placeholder="Your full name" />
          </div>
          {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>}
        </div>

        <div>
          <label className="input-label">Email Address</label>
          <div className="relative">
            <RiMailLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('email', { required: 'Email required', pattern: { value: /^\S+@\S+\.\S+$/, message: 'Invalid email' } })}
              className="input-field pl-10" placeholder="you@example.com" type="email" />
          </div>
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
        </div>

        <div>
          <label className="input-label">Phone Number</label>
          <div className="relative">
            <RiPhoneLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('phone', { required: 'Phone required', pattern: { value: /^[6-9]\d{9}$/, message: 'Enter valid 10-digit number' } })}
              className="input-field pl-10" placeholder="98765 43210" type="tel" />
          </div>
          {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone.message}</p>}
        </div>

        <div>
          <label className="input-label">Password</label>
          <div className="relative">
            <RiLockLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('password', { required: 'Password required', minLength: { value: 8, message: 'Minimum 8 characters' } })}
              className="input-field pl-10 pr-10" placeholder="Min. 8 characters"
              type={showPw ? 'text' : 'password'} />
            <button type="button" onClick={() => setShowPw(!showPw)}
              className="absolute right-3.5 top-1/2 -translate-y-1/2 text-salon-muted hover:text-salon-dark transition-colors">
              {showPw ? <RiEyeOffLine /> : <RiEyeLine />}
            </button>
          </div>
          {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
        </div>

        <div>
          <label className="input-label">Confirm Password</label>
          <div className="relative">
            <RiLockLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('password_confirmation', {
              required: 'Please confirm password',
              validate: (v) => v === watch('password') || 'Passwords do not match',
            })}
              className="input-field pl-10" placeholder="Re-enter password" type="password" />
          </div>
          {errors.password_confirmation && <p className="text-red-500 text-xs mt-1">{errors.password_confirmation.message}</p>}
        </div>

        <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center py-3.5 text-base mt-2">
          {isSubmitting ? <><RiLoader4Line className="animate-spin" /> Creating account...</> : 'Create Account'}
        </button>
      </form>

      <p className="text-center text-sm font-body text-salon-muted mt-6">
        Already have an account?{' '}
        <Link to="/login" className="text-salon-primary font-semibold hover:underline">Sign in</Link>
      </p>
    </div>
  )
}
